import $ from 'jquery';

export default {
	init() {
		// List View
		$('.tablepress thead>tr th').attr('scope', 'col');
	},
};
